// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8144afbb","455":"3fbf6317"}[chunkId] + ".chunk.js";
};